// Containers/SalesPerDay15.jsx
import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { getUser } from "../../../auth";
import SalesPerDay15OldGraph from "../../components/VentasDatos/SalesPerDay15OldGraph";
import SalesPerDay15NewGraph from "../../components/VentasDatos/SalesPerDay15NewGraph";

const URL = process.env.REACT_APP_API_URL;

export default function SalesPerDay15() {
  const [lastQuincenaData, setLastQuincenaData] = useState([]);
  const [currentQuincenaData, setCurrentQuincenaData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        const user = getUser();
        const res = await fetch(
          `${URL}/api/sales/datos/summary/biweekly-sales-summary/`,
          {
            headers: { "X-Empresa-Id": user?.empresa_id },
          }
        );
        if (!res.ok) throw new Error("Error al obtener datos de ventas");
        const data = await res.json();
        setLastQuincenaData(data.last_quincena);
        setCurrentQuincenaData(data.current_quincena);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchSalesData();
  }, []);

  if (loading)
    return (
      <Box textAlign="center">
        <CircularProgress />
      </Box>
    );

  return (
    <Box>
      <Box mb={1} sx={{ height: "34vh" }}>
        <SalesPerDay15OldGraph data={lastQuincenaData} />
      </Box>
      <Box sx={{ height: "34vh" }}>
        <SalesPerDay15NewGraph data={currentQuincenaData} />
      </Box>
    </Box>
  );
}
